<script lang="ts">
    export let class_list: string[] = [];
</script>

<div class="chip {class_list.join(" ")}">
    <slot/>
</div>